import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { BRAND } from './generated/brand';
import { clearAuthToken, getAuthToken } from './utils/auth-storage';
import { startDeployVersionWatcher } from './utils/deployVersion';

const applyBrandLinks = () => {
  const cacheBuster = `client=${encodeURIComponent(BRAND.clientId)}`;

  if (BRAND.web.assetUrls.favicon) {
    document
      .querySelectorAll<HTMLLinkElement>('link[rel="icon"]')
      .forEach(link => {
        link.href = `${BRAND.web.assetUrls.favicon}?${cacheBuster}`;
      });
  }

  if (BRAND.web.assetUrls.appleTouchIcon) {
    document
      .querySelectorAll<HTMLLinkElement>('link[rel="apple-touch-icon"]')
      .forEach(link => {
        link.href = `${BRAND.web.assetUrls.appleTouchIcon}?${cacheBuster}`;
      });
  }
};

axios.defaults.baseURL =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  BRAND.web.apiBaseUrl;
axios.defaults.withCredentials = true;

axios.interceptors.request.use(config => {
  const token = getAuthToken();
  const existingAuthorization = (config.headers as Record<string, string> | undefined)?.Authorization;

  if (token && !existingAuthorization) {
    config.headers = config.headers ?? {};
    (config.headers as Record<string, string>).Authorization = `Bearer ${token}`;
  }

  return config;
});

axios.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401) {
      clearAuthToken();
    }

    return Promise.reject(error);
  }
);

if (document.title === 'Core Routes') {
  document.title = BRAND.web.appTitle || BRAND.displayName;
}

applyBrandLinks();

startDeployVersionWatcher();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
